import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { Card } from '../../../UI/UI';

const Container = styled(Card)`
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  width: 320px;
`;

const StatusText = styled(Typography)`
  font-size: unset;
`;

export { Container, StatusText };
